import {
    createRegisterableComponentWithData,
    isArticleLikeType,
} from '@news-mono/web-common'
import { TopicV4DTO } from '@west-australian-newspapers/publication-types'
import React from 'react'
import { ArticlePublicationDataDefinitionLoader } from '../../ArticlePublicationDataLoader'
import { getPublicationInfoFromRouteResolution } from '../../SharedPublication.routing'
import { TheWestArticleHeader } from './TheWestArticleHeader'

export type TheWestArticleHeaderRouteProps = {
    topics: { primary: TopicV4DTO; secondary: TopicV4DTO[] }
}

export const TheWestArticleHeaderRegistration =
    createRegisterableComponentWithData(
        'thewest-article-header',
        ArticlePublicationDataDefinitionLoader,
        (props: TheWestArticleHeaderRouteProps, data, services) => {
            const publicationInfo =
                getPublicationInfoFromRouteResolution(services)

            if (!isArticleLikeType(publicationInfo.publication)) {
                throw new Error(`Article component rendered for non-article.`)
            }

            if (data.loaded) {
                return (
                    <TheWestArticleHeader
                        topics={props.topics}
                        publication={publicationInfo.publication}
                    />
                )
            }

            return null
        },
    )
